
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PenLine } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface Profile {
  full_name: string | null;
  email: string | null;
  phone: string | null;
  specialization: string | null;
  tier: string | null;
}

interface PersonalInfoCardProps {
  profile: Profile;
}

export function PersonalInfoCard({ profile }: PersonalInfoCardProps) {
  const navigate = useNavigate();
  
  return (
    <Card className="backdrop-blur-lg bg-white/10 border-white/20">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-white">Personal Information</CardTitle>
        <Button 
          variant="ghost" 
          size="icon" 
          className="text-white/70 hover:text-white hover:bg-white/10"
          onClick={() => navigate('/settings')}
        >
          <PenLine className="h-4 w-4" />
        </Button>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-1">
            <span className="text-white/70 block">Email</span>
            <span className="text-white block">{profile.email}</span>
          </div>
          <div className="space-y-1">
            <span className="text-white/70 block">Phone</span>
            <span className="text-white block">{profile.phone}</span>
          </div>
          <div className="space-y-1">
            <span className="text-white/70 block">Membership</span>
            <span className="text-white block">{profile.tier || 'Beta'}</span>
          </div>
          <div className="space-y-1">
            <span className="text-white/70 block">Specialisation</span>
            <span className="text-white block">{profile.specialization || 'Not specified'}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
